import React from "react";

const Base64toImage = ({ code }) => {
  let source = "data:image/png;base64,";
  source += code;
  return <img className="circle-img" src={source} alt="" />;
};

export default Base64toImage;
